const setIfValue = (p, k, v) => (v ? p.set(k, v) : p.delete(k));
const dropPagination = p => p.delete("page");
const PER_PAGE = 9;
const normalizeTag = (s) => (s || "")
  .toLowerCase()
  .replace(/\s*:\s*/g, ":")
  .replace(/[-_]+/g, " ")
  .replace(/\s+/g, " ")
  .trim();
class MainSearch extends SearchForm {
  constructor() {
    super();
    this.root = document.querySelector(".template-search");
    if (!this.root) return;
    this.isArticlePage = new URL(location.href).searchParams.get("type") === "article";
    this.isB2B = this.root.dataset.isB2b === "true";
    const urlStoreBrand = new URL(location.href).searchParams.get("store_brand");
    if (urlStoreBrand) try { localStorage.setItem("store_brand", urlStoreBrand); } catch(e) {}
    this.brandSlug = urlStoreBrand || localStorage.getItem("store_brand") || this.root.dataset.brandSlug || "";
    console.log("brandSlug:", this.brandSlug);
    this.vendorFilter = { "ethical-nutrients": "Ethical Nutrients", "inner-health": "Inner Health", "metagenics": "Metagenics" }[this.brandSlug] || "Metagenics";
    console.log("vendorFilter:", this.vendorFilter);
    this.brandBlogTag = ({
      "ethical-nutrients": "blog:Ethical Nutrients",
      "inner-health": "blog:Inner Health",
      "metagenics": "blog:Metagenics Health & Wellness",
      "metagenics-institute": "blog:Metagenics Institute"
    })[this.brandSlug] || "blog:Metagenics Health & Wellness";
    this.latestNewsTag = "blog:Metagenics Latest News";
    this.getRequiredTag = () => {
      const isInstitute = this.brandSlug === "metagenics-institute";
      return (this.isB2B && !isInstitute) ? this.latestNewsTag : this.brandBlogTag;
    };

    // On the global Search page, force Institute context for Articles without touching the URL
    const __isSearchPath = location.pathname.replace(/\/+$/, '') === '/search';
    if (__isSearchPath) {
      // If brand is not explicitly provided, assume Metagenics Institute to scope getRequiredTag()
      if (!this.brandSlug){
        this.brandSlug = 'metagenics-institute';
        this.brandBlogTag = 'blog:Metagenics Institute';
      }
    }

    console.log("[Search] isArticlePage:", this.isArticlePage, "isB2B:", this.isB2B);
    console.log("[Search] brandSlug:", this.brandSlug, "brandBlogTag:", this.brandBlogTag, "latestNewsTag:", this.latestNewsTag);
    this.stabilizeSearchUrl();
    this.setupViewSwitcher();
    this.enforceBrandScope();
    this.setupSearchSync();
    if (this.isArticlePage) this.initArticleMode();
  }

  initArticleMode() {
    this.cardContainer = document.querySelector("ul.product-grid");
    this.articleCards = Array.from(this.cardContainer.querySelectorAll("[data-article-tags]"));

    this.articleCardsOriginal = this.articleCards.slice();
    console.log("All article cards (before blog tag filtering):", this.articleCardsOriginal.map(c => ({
      title: c.dataset.articleTitle,
      tags: c.dataset.articleTags
    })));

    // Auto-load more pages when Institute tag is required but current page lacks matches
    (async () => {
      const requiredTagNorm = normalizeTag(this.getRequiredTag());
      const needsInstitute = this.brandSlug === 'metagenics-institute';
      const parseTags = c => (c.dataset.articleTags || '').split(',').map(t => normalizeTag(t));
      const hasRequired = c => parseTags(c).includes(requiredTagNorm);

      let matchedNow = (this.articleCardsOriginal || []).filter(hasRequired).length;
      // For non-Institute brands, we don't need autoload unless nothing matched at all
      const needAuto = needsInstitute || matchedNow === 0;
      if (!needAuto) return;

      const TARGET_MATCHES = 12;     // try to collect at least 12 matching cards
      const MAX_PAGES      = 20;     // hard stop to avoid excessive fetches
      let page = 2;
      let hadAnyPage = true;

      while (matchedNow < TARGET_MATCHES && page <= MAX_PAGES && hadAnyPage) {
        const url = new URL(location.href);
        url.searchParams.set('page', String(page));
        try {
          const html = await fetch(url.toString(), { credentials: 'same-origin' }).then(r => r.text());
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const lis = Array.from(doc.querySelectorAll('ul.product-grid li[data-article-tags]'));
          hadAnyPage = lis.length > 0;
          if (!hadAnyPage) break; // no more results

          // Append ALL incoming items; client-side filter will hide non-matching ones
          if (lis.length) {
            const frag = document.createDocumentFragment();
            lis.forEach(li => frag.appendChild(li.cloneNode(true)));
            this.cardContainer.appendChild(frag);

            // refresh collections
            this.articleCards = Array.from(this.cardContainer.querySelectorAll('[data-article-tags]'));
            this.articleCardsOriginal = this.articleCards.slice();
            matchedNow = (this.articleCardsOriginal || []).filter(hasRequired).length;
          }
        } catch (e) {
          console.warn('[Search] autoload error', e);
          break;
        }
        page += 1;
      }

      // Fallback: if still no matches for Institute after autoload, fetch by tag ONLY (drop q) and append results
      if (needsInstitute) {
        matchedNow = (this.articleCardsOriginal || []).filter(hasRequired).length;
        if (matchedNow === 0) {
          try {
            const base = new URL(location.href);
            base.searchParams.delete('q');
            base.searchParams.set('type', 'article');
            base.searchParams.set('tag', this.getRequiredTag());
            base.searchParams.delete('page');

            // Try first 3 pages of pure tag search
            let appended = 0;
            for (let p = 1; p <= 3; p++) {
              if (p > 1) base.searchParams.set('page', String(p));
              const html = await fetch(base.toString(), { credentials: 'same-origin' }).then(r => r.text());
              const doc  = new DOMParser().parseFromString(html, 'text/html');
              const lis  = Array.from(doc.querySelectorAll('ul.product-grid li[data-article-tags]'));
              if (!lis.length) break;
              const frag = document.createDocumentFragment();
              lis.forEach(li => frag.appendChild(li.cloneNode(true)));
              this.cardContainer.appendChild(frag);
              appended += lis.length;
            }
            // refresh collections and recompute
            if (appended > 0) {
              this.articleCards = Array.from(this.cardContainer.querySelectorAll('[data-article-tags]'));
              this.articleCardsOriginal = this.articleCards.slice();
            }
          } catch (e) {
            console.warn('[Search] institute fallback error', e);
          }
        }
      }
    })();

    this.buildArticleFacetsFromCards();

    const sortSelect = document.getElementById("ArticleSortBy");
    if (sortSelect) {
      sortSelect.addEventListener("change", () => {
        const map = {
          "recommended": "recommended",
          "created-descending": "date-desc",
          "created-ascending": "date-asc",
          "title-ascending": "title-asc",
          "title-descending": "title-desc"
        };
        const mode = map[sortSelect.value] || "recommended";
        this.applyArticleSort(mode);
        window.scrollTo({ top: this.cardContainer.offsetTop - 80, behavior: "smooth" });
      });
    }
    Promise.resolve().then(() => {
      const total = this.applyArticleFilter();
      this.buildPager(total, 1);
    });

    const facets = document.getElementById("ArticleFacets");
    facets?.addEventListener("change", () => {
      const t = this.applyArticleFilter();
      this.buildPager(t, 1);
      window.scrollTo({ top: this.cardContainer.offsetTop - 80, behavior: "smooth" });
    });
  }

  buildArticleFacetsFromCards() {
    const facetsForm = document.getElementById('ArticleFacets');
    if (!facetsForm) return;
    const list = facetsForm.querySelector('ul.facets-layout');
    if (!list) return;

    const requiredTag = normalizeTag(this.getRequiredTag());

    // Collect unique filter:: tags from cards that have the required blog tag
    const tagsSet = new Set();
    (this.articleCardsOriginal || []).forEach(card => {
      const tags = (card.dataset.articleTags || '')
        .split(',')
        .map(t => normalizeTag(t));
      if (!tags.includes(requiredTag)) return;
      tags.forEach(t => { if (t.startsWith('topic:')) tagsSet.add(t); });
    });

    // Preserve currently checked values if any
    const prevChecked = new Set(Array.from(list.querySelectorAll('input[type="checkbox"]:checked')).map(i => i.value.toLowerCase()));

    // Rebuild the list
    list.innerHTML = '';
    let idx = 0;
    Array.from(tagsSet).sort().forEach(tag => {
      idx += 1;
      const id = `ArticleFacet-${idx}`;
      const labelText = tag.replace('topic:','').replace(/-/g,' ').replace(/\b\w/g, c => c.toUpperCase());
      const checked = prevChecked.has(tag) ? ' checked' : '';
      const li = document.createElement('li');
      li.className = 'list-menu__item facets__item';
      li.innerHTML = `
        <label class="facets__label facet-checkbox" for="${id}">
          <input type="checkbox" id="${id}" value="${tag.replace(/&/g,'&amp;').replace(/"/g,'&quot;')}"${checked}>

          <svg width="16" height="16" class="icon-checkbox--empty" viewBox="0 0 16 16" aria-hidden="true" focusable="false" fill="none">
            <path d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H12C13.933 0.5 15.5 2.067 15.5 4V12C15.5 13.933 13.933 15.5 12 15.5H4C2.067 15.5 0.5 13.933 0.5 12V4Z" fill="white"></path>
            <path d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H12C13.933 0.5 15.5 2.067 15.5 4V12C15.5 13.933 13.933 15.5 12 15.5H4C2.067 15.5 0.5 13.933 0.5 12V4Z" stroke="#D4D4D4"></path>
          </svg>

          <svg aria-hidden="true" class="icon icon-checkmark" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4Z" fill="#002854"/>
            <path d="M12 5L6.5 10.5L4 8" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>

          <span class="facet-checkbox__text" aria-hidden="true">
            <span class="facet-checkbox__text-label">${labelText}</span>
          </span>
          <span class="visually-hidden">${tag.replace('topic:','')}</span>
        </label>`;
      list.appendChild(li);
    });
  }

  applyArticleFilter() {
    const checked = Array.from(
        document.querySelectorAll('#ArticleFacets input:checked'),
        i => normalizeTag(i.value)
    );

    // Always require the brand/b2b blog tag on Articles
    const requiredTag = normalizeTag(this.getRequiredTag());

    console.log("[Search] requiredTag:", requiredTag);

    this.articleCards.forEach(card => {
      const tags = (card.dataset.articleTags || '')
          .split(',')
          .map(t => normalizeTag(t));

      // Card must have the required blog tag (brand or latest news)
      const hasRequired = tags.includes(requiredTag);

      if (!hasRequired && (tags.includes("blog:metagenics health & wellness") || tags.includes("blog:inner health") || tags.includes("blog:ethical nutrients"))) {
        console.log("[Search] hiding card due to requiredTag mismatch:", { title: card.dataset.articleTitle, tags, requiredTag });
      }

      const showByFacets = !checked.length || checked.some(t => tags.includes(t));
      const show = hasRequired && showByFacets;

      card.hidden = !show;
      card.style.display = '';
    });

    const shown = this.articleCards.filter(c => !c.hidden).length;

    const native = document.querySelector('nav.pagination');
    if (native) native.style.display = checked.length ? 'none' : '';

    this.updateArticleCount(shown);
    return shown;
  }

  applyArticleSort(mode) {
    if (!this.cardContainer || !this.articleCardsOriginal) return;

    let items = this.articleCardsOriginal.slice();
    const m = ({
      "created-descending": "date-desc",
      "created-ascending": "date-asc",
      "title-ascending": "title-asc",
      "title-descending": "title-desc",
      "date-desc": "date-desc",
      "date-asc": "date-asc",
      "title-asc": "title-asc",
      "title-desc": "title-desc",
      "recommended": "recommended"
    })[mode] || "recommended";

    if ( m === "date-desc" || m === "date-asc") {
      items.sort((a, b) => {
        const da = parseInt(a.dataset.articleDate || "0", 10);
        const db = parseInt(b.dataset.articleDate || "0", 10);
        return mode === "date-desc" ? (db - da) : (da - db);
      });
    } else if (m === "title-asc" || m === "title-desc") {
      items.sort((a, b) => {
        const ta = (a.dataset.articleTitle || "").toLowerCase();
        const tb = (b.dataset.articleTitle || "").toLowerCase();
        if (ta < tb) return mode === "title-asc" ? -1 : 1;
        if (ta > tb) return mode === "title-asc" ? 1 : -1;
        return 0;
      });
    }

    const frag = document.createDocumentFragment();
    items.forEach(li => frag.appendChild(li));
    this.cardContainer.appendChild(frag);

    this.articleCards = items;

    const total = this.applyArticleFilter();
    this.buildPager(total, 1);
  }

  buildPager(total, current) {
    document.getElementById('client-article-pagination')
        ?.parentElement?.remove();

    const pages = Math.ceil(total / PER_PAGE);
    if (pages <= 1) return;


    const nav = document.createElement('nav');
    nav.className = 'pagination';

    const ul  = document.createElement('ul');
    ul.id     = 'client-article-pagination';
    ul.className = 'pagination__list list-unstyled';
    ul.setAttribute('role', 'list');
    nav.append(ul);


    const svgCaret =
        '<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">' +
        '<path fill-rule="evenodd" clip-rule="evenodd" ' +
        'd="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>' +
        '</svg>';

    const li = html => { const el=document.createElement('li'); el.innerHTML=html; return el; };

    const pageLink = (p, isCur=false) => isCur
        ? `<a role="link" aria-disabled="true"
         class="pagination__item pagination__item--current"
         aria-current="page">${p}</a>`
        : `<a href="#" class="pagination__item link"
         data-page="${p}" aria-label="Page ${p}">${p}</a>`;

    const dots = () => '<span class="pagination__item">…</span>';

    const arrow = (dir, page) => {
      const cls = dir === 'prev' ? 'pagination__item--next'
          : 'pagination__item--prev';
      const label = dir === 'prev' ? 'Previous page' : 'Next page';
      return `<a href="#" class="pagination__item ${cls} pagination__item-arrow link motion-reduce"
               data-page="${page}" aria-label="${label}">${svgCaret}</a>`;
    };


    if (current > 1) ul.append(li(arrow('prev', current - 1)));

    const add = p => ul.append(li(pageLink(p, p === current)));

    if (pages <= 7) {
      for (let p = 1; p <= pages; p++) add(p);
    } else {
      add(1); add(2);

      if (current <= 3) {
        add(3); add(4); ul.append(li(dots()));
      } else if (current >= pages - 2) {
        ul.append(li(dots()));
        add(pages - 3); add(pages - 2);
      } else {
        ul.append(li(dots()));
        add(current - 1); add(current); add(current + 1);
        ul.append(li(dots()));
      }

      add(pages - 1); add(pages);
    }

    if (current < pages) ul.append(li(arrow('next', current + 1)));

    this.cardContainer.after(nav);
    this.sliceToPage(current);

    nav.addEventListener('click', e => {
      const a = e.target.closest('a[data-page]');
      if (!a) return;
      e.preventDefault();
      const page = +a.dataset.page;
      this.sliceToPage(page);
      this.buildPager(total, page);
      window.scrollTo({ top: this.cardContainer.offsetTop - 80, behavior: 'smooth' });
    });
  }
  sliceToPage(page) {
    const start = (page - 1) * PER_PAGE;
    const end   = page * PER_PAGE;
    let i = -1;

    this.articleCards.forEach(c => {
      if (c.hidden) {
        c.style.display = 'none';
        return;
      }
      i += 1;
      const show = i >= start && i < end;
      c.style.display = show ? '' : 'none';
    });
  }

  updateArticleCount(t) {
    const el = document.getElementById("ArticleCount");
    if (el) el.textContent = `${t} ${t === 1 ? "article" : "articles"}`;

    // Also fix the MAIN (top) header count to reflect filtered Articles results
    if (this.isArticlePage) {
      const top = document.getElementById("ProductCount");
      if (top) {
        const q = new URL(location.href).searchParams.get("q") || "";
        const terms = q.replace(/\+/g, ' ').trim();
        top.textContent = `${t} search results for “${terms}”`;
      }
    }
  }

  setupViewSwitcher() {
    const pLink = this.root.querySelector(".search-switch__link.products");
    const aLink = this.root.querySelector(".search-switch__link.articles");
    if (!pLink || !aLink) return;
    const isArt = this.isArticlePage;
    aLink.classList.toggle("search-switch__link--active", isArt);
    pLink.classList.toggle("search-switch__link--active", !isArt);
    pLink.onclick = e => { e.preventDefault(); this.switchTo("product"); };
    aLink.onclick = e => { e.preventDefault(); this.switchTo("article"); };
  }
  switchTo(type) {
    const u = new URL(location.href); const p = u.searchParams;
    p.set("type", type);
    if (type === "article") {
      [...p.keys()].filter(k => k.startsWith("filter.")).forEach(k => p.delete(k));
      dropPagination(p);
      if (this.brandSlug === "metagenics-institute") {
        setIfValue(p, "tag", this.getRequiredTag()); // ensures server returns only Institute-tagged articles
      } else {
        setIfValue(p, "tag", this.getRequiredTag());
      }
    } else {
      p.delete("tag"); dropPagination(p);
      if (!this.isB2B) setIfValue(p, "filter.p.vendor", this.vendorFilter);
    }
    location.href = u.pathname + "?" + p.toString();
  }

  stabilizeSearchUrl() {
    // Keep query params stable on /search across reloads without navigating
    const isSearch = location.pathname.replace(/\/+$/, '') === '/search';
    if (!isSearch) return;

    const u = new URL(location.href);
    const before = u.search;

    // Remember/restore the search query across reloads
    try {
      const currQ = (u.searchParams.get('q') || '').trim();
      if (currQ) {
        sessionStorage.setItem('__search_q', currQ);
      } else {
        const fallbackQ = (document.getElementById('Search-In-Template')?.value || sessionStorage.getItem('__search_q') || '').trim();
        if (fallbackQ) u.searchParams.set('q', fallbackQ);
      }
    } catch (e) {}

    // For Metagenics Institute, ensure type=article and required tag present,
    // but do not remove any other existing params
    try {
      const desired = (typeof this.getRequiredTag === 'function') ? this.getRequiredTag() : '';
      if (this.brandSlug === 'metagenics-institute' && desired) {
        u.searchParams.set('type', 'article');
        const currTag = (u.searchParams.get('tag') || '');
        if (normalizeTag(currTag) !== normalizeTag(desired)) {
          u.searchParams.set('tag', desired);
        }
      }
    } catch (e) {}

    // Only rewrite URL if we actually changed something; use replaceState to avoid reload loops
    if (u.search !== before) {
      history.replaceState(null, '', u.pathname + u.search);
    }
  }

  enforceBrandScope() {
    // Avoid enforcing on the global Search page to prevent redirect loops
    const isSearchPath = location.pathname.replace(/\/+$/, '') === '/search';
    if (isSearchPath) return;

    const u = new URL(location.href);
    const p = u.searchParams;
    if (this.isArticlePage) {
      const desired = this.getRequiredTag();
      console.log("[Search] enforceBrandScope", { urlTag: p.get("tag"), desired, brandSlug: this.brandSlug });
      if (p.get("tag") !== desired) {
        p.set("tag", desired);
        location.replace(u.pathname + "?" + p.toString());
      }
    }
  }

  setupSearchSync() {
    const ins = document.querySelectorAll("input[type='search']");
    if (!ins.length) return;
    const sync = src => {
      // Skip if source is f-ing-search field
      if (src.id === 'f-ing-search') return;
      
      ins.forEach(i => {
        // Skip the f-ing-search field to prevent duplication
        if (i !== src && i.id !== 'f-ing-search') {
          i.value = src.value;
        }
      });
    };
    ins.forEach(i => i.addEventListener("input", e => sync(e.target)));
  }
}

customElements.define("main-search", MainSearch);